<div
  class="generic-dialog"
  [class.generic-dialog--fullscreen]="privateFullscreen"
  [class.generic-dialog--more-height]="increasedHeight">
  <div
    class="generic-dialog__header"
    [class.generic-dialog__header--full]="header.type === 'full'"
    [class.generic-dialog__header--none]="header.type === 'none'"
    [class.generic-dialog__header--onlyTitle]="header.type === 'onlyTitle'"
    [class.generic-dialog__header--user]="header.type === 'user' || header.type === 'logo'">
    <div
      class="generic-dialog__back"
      [ngClass]="{ 'hide-icon': hideBackIcon }">
      <button
        class="sharry-xs"
        color="secondary"
        mat-icon-button
        [disabled]="hideBackIcon"
        (click)="back.emit()">
        <sharry-icon
          class="svg-icon"
          registryName="caret-left"></sharry-icon>
      </button>
    </div>
    <div class="generic-dialog__header__central-container">
      @if (header.type === 'user') {
        <div
          class="generic-dialog__header__img"
          [avatar]="{
            size: 'small',
            imgSize: '40px',
            user: { sharrylandPartner: userType.sharrylandPartner, role: userType.role },
            imgValueUrl: header.imgUrl,
            noBorder: userType.noBorder,
          }"
          (click)="avatarClicked.emit($event)"></div>
      }
      @if (header.type === 'logo') {
        <img
          class="generic-dialog__header__img"
          height="31"
          width="22"
          [src]="header.imgUrl"
          [alt]="'logo'"
          (click)="avatarClicked.emit($event)" />
      }
      <div class="generic-dialog__header__title-container">
        @if (header.type !== 'none') {
          <h4
            class="generic-dialog__header__title"
            [innerHTML]="header.title | i18next | safe: 'html'"></h4>
        }
        @if (header.type === 'full' || header.type === 'user') {
          <p
            class="generic-dialog__header__subtitle"
            [innerHTML]="header.subtitle | i18next"></p>
        }
      </div>
    </div>
    <div
      class="generic-dialog__close"
      [ngClass]="{ 'hide-icon': hideCloseIcon }">
      <button
        class="sharry-xs"
        color="secondary"
        mat-icon-button
        [disabled]="hideCloseIcon"
        (click)="cancel.emit()">
        <sharry-icon
          class="svg-icon"
          registryName="x"></sharry-icon>
      </button>
    </div>
  </div>
  <div
    class="generic-dialog__content"
    [class.generic-dialog__content--no-footer]="footerType === 'none'"
    [ngStyle]="{ 'background-color': !!backgroundColor ? backgroundColor : undefined }">
    <ng-content></ng-content>
  </div>
  <div
    class="generic-dialog__footer"
    [class.generic-dialog__footer--fullscreen]="privateFullscreen"
    [class.generic-dialog__footer--none]="footerType === 'none'"
    [class.generic-dialog__footer--align-start]="footerAlignStart">
    @if (footerType === 'template') {
      <ng-container
        [ngTemplateOutlet]="footerTemplate"
        [ngTemplateOutletContext]="{ $implicit: footerTemplateContext }"></ng-container>
    }
    @if (footerType !== 'template') {
      @if (footerType !== 'none') {
        @if (footerType === 'standardWithText') {
          <p [innerHTML]="footerText"></p>
        }
        @if (!hideFooterClose) {
          <button
            class="sharry-medium"
            color="secondary"
            mat-stroked-button
            (click)="cancel.emit()">
            {{ 'generic-dialog.undo' | i18next }}
          </button>
        }
        @if (footerType !== 'deleteUser' && !hideFooterConfirm) {
          <button
            class="sharry-medium"
            color="primary"
            mat-flat-button
            [disabled]="disabled"
            [class.grow]="footerType === 'standardGrow'"
            (click)="confirm.emit()">
            {{ footerStandardButtonLabel || 'generic-dialog.confirm' | i18next }}
          </button>
        }
        @if (footerType === 'deleteUser' && !hideFooterDelete) {
          <button
            class="sharry-medium"
            color="warn"
            mat-flat-button
            [disabled]="disabled"
            (click)="confirm.emit()">
            {{ 'generic-dialog.delete-account' | i18next }}
          </button>
        }
      }
    }
  </div>
</div>
